import { Component, Input, OnInit } from '@angular/core';
import { PopoverController, ModalController } from '@ionic/angular';
import { ShareValuesService } from 'src/app/services/sharedValues/share-values.service';
import { BackendCallService } from '../../services/backend-call/backend-call.service';
import { ToastService } from '../../services/toast.service';
import { AppConstants } from '../../utilities/constant';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-multiselect-search',
  templateUrl: './multiselect-search.component.html',
  styleUrls: ['./multiselect-search.component.scss'],
})
export class MultiselectSearchComponent implements OnInit {
  @Input() type: any;
  @Input() userInfo: any;
  public orgList = [];
  public filteredOrgs = [];
  public selectedOrgs: any[] = [];
  constructor(public popoverController: PopoverController,
    public sharedValue: ShareValuesService,
    private backendCallService: BackendCallService,
    private toastService: ToastService,
    public modalController: ModalController,
    public translate: TranslateService
  ) { }

  ngOnInit() {}

  /**
   * Adds sales org
   */
  public addSalesOrg() {
    const lstUserSalesOrgAssociationDetails = [];
    this.selectedOrgs.forEach(element => {
      lstUserSalesOrgAssociationDetails.push(
        {
          userId: this.userInfo.Id,
          salesOrgId: element.salesOrgId,
          isFromSap: element.isFromSap,
          isActive: element.isActive
        }
      );
    });
    const payload = { lstUserSalesOrgAssociationDetails };
    this.backendCallService.addUserSalesOrg(payload).subscribe((res: any) => {
      if (res.statusCode == 200) {
        this.toastService.presentToast(this.translate.instant('sales_organization_added_successfully'), 4000, AppConstants.SUCCESS_SNACKBAR, 'top');
        this.modalController.dismiss({
          updated: true,
        });
      }
    });
  }

  /**
   * Gets users
   *
   * @param event event
   */
  public getSalesOrg(event) {
    const searchTerm = event.detail.value.toLowerCase();
    if (searchTerm.length >=3) {
      this.filteredOrgs = [];
      this.assignSalesOrg(searchTerm);
    } else {
      this.filteredOrgs = [];
    }
  }

  /**
   * Determines whether checkbox change on
   *
   * @param user user
   */
  public onCheckboxChange(org: any) {
    if (org.selected) {
      this.selectedOrgs.push(org);
    } else {
      this.selectedOrgs = this.selectedOrgs.filter(o => o.Id !== org.Id);
    }
  
    // Get selected organization IDs
    const selectedOrgIds = new Set(this.selectedOrgs.map(o => o.Id));
  
    // Filter orgList to exclude selected orgs
    this.filteredOrgs = this.filteredOrgs
      .filter(o => !selectedOrgIds.has(o.Id)) // Exclude selected orgs      
  }

  /**
   * Assigns sales org
   *
   * @param searchValue
   */
  private assignSalesOrg(searchValue) {
    this.orgList = [];
    this.backendCallService.getAllSalesOrganization().then((res) => {
      this.orgList = res.response;
    
      // Convert selectedOrgs to a Set for faster lookups (optional but recommended)
      const selectedOrgIds = new Set(this.selectedOrgs.map(org => org.Id));
    
      this.filteredOrgs = this.orgList
        .filter(org =>
          org.company.toLowerCase().includes(searchValue.toLowerCase()) &&
          !selectedOrgIds.has(org.id) &&
          !this.userInfo.UserSalesOrgAssociation.some(userOrg => userOrg.SalesOrgId === org.sales_org)
        )
        
        .map(org => ({
          Display_Name: org.company,
          Id: org.id,
          isActive: org.is_active,
          isFromSap: org.is_from_sap,
          salesOrgId: org.sales_org
        }));
    });
  }

  /**
   * Closes search with multi select checkbox component
   */
  public close() {
    this.modalController.dismiss({
      updated: false,
    });
  }

  /**
   * Removes org
   *
   * @param data
   */
  public removeOrg(data) {
    // Remove the item from selectedOrgs
    this.selectedOrgs = this.selectedOrgs.filter(item => item.Id !== data.Id);
    // Find and update the selected property of the item in filteredOrgs
    const selectedData = this.filteredOrgs.find(item => item.Id === data.Id);
    if (selectedData && selectedData.selected) {
      selectedData.selected = false;
    }
  }
}
